import { HighlightOutlined } from '@ant-design/icons';
import { Card, Divider, Timeline, Typography } from 'antd';
import moment from 'moment';
import { Trans } from 'react-i18next';

import { InterviewHistoryChangedFields } from '../../types';
import { CandidateHistoryCollectionSerializer } from '../../types/api';

interface ApplicantInterviewEventTimelineProps {
  createdAt: string;
  recruiterName: string;
  opportunityTitle?: string;
  interviewHistoryEventType: CandidateHistoryCollectionSerializer['interview_history_type'];
  interviewHistoryChangedFields?: InterviewHistoryChangedFields;
  atStage: string;
}

const ApplicantInterviewEventTimeline = ({
  recruiterName,
  createdAt,
  opportunityTitle,
  atStage,
  interviewHistoryEventType,
  interviewHistoryChangedFields,
}: ApplicantInterviewEventTimelineProps) => {
  return (
    <Timeline.Item dot={<HighlightOutlined />}>
      <Card>
        <Typography.Text type="secondary">{moment(createdAt).format('LLL')}</Typography.Text>
        <br />
        <Typography.Text strong>{recruiterName}</Typography.Text>
        {interviewHistoryEventType === 'INTERVIEW_STARTED' && (
          <Typography.Text>
            {' '}
            <Trans>iniciou a entrevista</Trans>{' '}
          </Typography.Text>
        )}
        {interviewHistoryEventType === 'INTERVIEW_FINISHED' && (
          <Typography.Text>
            {' '}
            <Trans>finalizou a entrevista</Trans>{' '}
          </Typography.Text>
        )}
        {interviewHistoryEventType === 'INTERVIEW_CHANGED' && (
          <Typography.Text>
            {' '}
            <Trans>fez alterações na entrevista</Trans>{' '}
          </Typography.Text>
        )}
        <Trans>na etapa</Trans>
        <Typography.Text strong> {atStage} </Typography.Text>
        <Trans>na vaga</Trans> <Typography.Text strong> {opportunityTitle} </Typography.Text>.
        {interviewHistoryEventType === 'INTERVIEW_CHANGED' && (
          <>
            <Divider />
            <Trans>Campos alterados:</Trans>
            <br />
            <br />
            {interviewHistoryChangedFields?.opinion_status === 'IN_ANALYSIS' && (
              <>
                <Typography.Text>
                  <Trans>Parecer da entrevista:</Trans>{' '}
                  <Typography.Text type="warning" strong>
                    <Trans>Em análise</Trans>
                  </Typography.Text>
                </Typography.Text>
                <br />
              </>
            )}
            {interviewHistoryChangedFields?.opinion_status === 'QUALIFIED' && (
              <>
                <Typography.Text>
                  <Trans>Parecer da entrevista:</Trans>{' '}
                  <Typography.Text type="success" strong>
                    <Trans>Qualificado</Trans>
                  </Typography.Text>
                </Typography.Text>
                <br />
              </>
            )}
            {interviewHistoryChangedFields?.opinion_status === 'NOT_QUALIFIED' && (
              <>
                <Typography.Text>
                  <Trans>Parecer da entrevista:</Trans>{' '}
                  <Typography.Text type="danger" strong>
                    <Trans>Não qualificado</Trans>
                  </Typography.Text>
                </Typography.Text>
                <br />
              </>
            )}
            {interviewHistoryChangedFields?.opinion_justification && (
              <>
                <Typography.Text>
                  <Trans>Justificativa alterada.</Trans>
                </Typography.Text>
                <br />
              </>
            )}
            {interviewHistoryChangedFields?.annotations && (
              <>
                <Typography.Text>
                  <Trans>Anotações alteradas.</Trans>
                </Typography.Text>
                <br />
              </>
            )}
          </>
        )}
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantInterviewEventTimeline;
